import api from '@/rest-api'

export default {
    searchPlace(place) {
        return api.get(`/google/search?query=${place}`)
    },
}